import React from "react";
import { AgreementActivity } from "../../../api/services";
import { ActivityListItem } from "./ActivityListItem";
import { AgreementIcon } from "../../../icons";
import { useAgreementActivity } from "../hooks/useAgreementActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const AgreementActivityItem: React.FC<{
  activity: AgreementActivity;
}> = ({ activity }) => {
  const { title, link } = useAgreementActivity(activity);
  return (
    <ActivityListItem
      icon={<AgreementIcon width={16} height={16} />}
      title={title}
      activityDttm={activity.activityDttm}
      linkTo={link}
    />
  );
};

export const AgreementActivitySummaryCell: React.FC<{
  activity: AgreementActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title } = useAgreementActivity(activity);
  return (
    <ActivitySummaryCell
      isGrey={isGrey}
      icon={<AgreementIcon width={16} height={16} />}
      summary={title}
    />
  );
};
